// @flow
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import TextField from 'material-ui/TextField';

import enhancer from '../../enhancer';

const User = ({ node }) => (
  <div>
    <form>
      <TextField
        floatingLabelText="Email"
        value={node.email}
        floatingLabelFixed
      />
      <br />
      <TextField
        floatingLabelText="Status"
        value={node.status}
        floatingLabelFixed
      />
      <br />
      <br />
    </form>
  </div>
);

const query = graphql`
  query UserAdminQuery($nodeId: ID!) {
    node(id: $nodeId) {
      ...User_node
    }
  }
`;

export default enhancer(User, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(User, {
        node: graphql`
          fragment User_node on User {
            id
            email
            status
            active
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/entity/user/User.js